import { get, post } from '../../../../util/api'
import { getUIDefinitionByTaskName } from '../../ui-definition/ui-definition'
import * as selector from '../task-detail/selector'
import * as type from './type'
import * as processAction from '../../ui-definition/process-action'

import { processInstanceLoaded } from '../../state/instance-detail/action'
import { findSalesOrderSuccess } from '../../../sales-order/state/detail/action'
import { findCustomerSuccess } from '../../../customer/state/detail/action'
import { treatmentPlanLoaded } from '../../../treatment/state/plan/action'
import { customerLoaded, processTaskLoaded } from '../../../treatment/state/quotation/action'
import { enrichTaskDetail } from './enrich-task-detail'
import { findProspectSuccess } from '../../../prospect/state/detail/action'
import { selectProcessInstance } from '../instance-detail/selector'
import { findInvoiceById } from '../../../invoice/state/correction/action'

const ACTION_MAPPING = {
    [processAction.CUSTOMER]: findCustomerSuccess,
    [processAction.SALES_ORDER]: findSalesOrderSuccess,
    [processAction.PROCESS_INSTANCE]: processInstanceLoaded,
    [processAction.TREATMENT_PLAN]: treatmentPlanLoaded,
    [processAction.TREATMENT_QUOTATION]: processTaskLoaded,
    [processAction.PROSPECT_LOADED]: findProspectSuccess,
    [processAction.QUOTATION_CUSTOMER_LOADED]: customerLoaded,
    [processAction.INVOICE_CORRECTION]: findInvoiceById,
}

export const findTaskDetailRequest = () => ({
    type: type.FIND_TASK_DETAIL_REQUEST,
    payload: {},
})

export const findTaskDetailSuccess = (task) => ({
    type: type.FIND_TASK_DETAIL_SUCCESS,
    payload: {
        task,
    },
})

export const findTaskDetailError = (error) => ({
    type: type.FIND_TASK_DETAIL_ERROR,
    payload: {
        error,
    },
})

export const invokeTaskActionList = (task, dispatch) => {
    const { actionList } = getUIDefinitionByTaskName(task.name)

    actionList.map(({ action, taskPath }) => {
        action = ACTION_MAPPING[action]

        if (!action) {
            return null
        }

        let actionData = task

        for (let index = 0; index < taskPath.length; index++) {
            const key = taskPath[index]
            actionData = actionData ? actionData[key] : null
        }
        return dispatch(action(actionData))
    })
}


export const findTaskDetail = (taskId) => (dispatch, getState) => {
    const state = getState()
    dispatch(findTaskDetailRequest())

    get('/api/process/task/find-by-id-full?processTaskId=' + taskId)
        .then(task => {
            invokeTaskActionList(task, dispatch)
            enrichTaskDetail(state, task)
            dispatch(findTaskDetailSuccess(task))
        })
        .catch(error => {
            dispatch(findTaskDetailError(error))
        })
}

export const findTaskDetailByProcessInstanceId = (processInstanceId) => (dispatch, getState) => {
    const state = getState()
    dispatch(findTaskDetailRequest())

    get('/api/process/partner/task/find-active-by-process-instance-id?processInstanceId=' + processInstanceId)
        .then(task => {
            invokeTaskActionList(task, dispatch)
            enrichTaskDetail(state, task)
            dispatch(findTaskDetailSuccess(task))
        })
        .catch(error => {
            dispatch(findTaskDetailError(error))
        })
}


export const toggleProcessFlowVisibility = () => ({
    type: type.TOGGLE_PROCESS_FLOW_VISIBILITY,
})


export const changeTaskDueDateRequest = () => ({
    type: type.CHANGE_DUE_DATE_REQUEST,
})

export const changeTaskDueDateSuccess = (due) => ({
    type: type.CHANGE_DUE_DATE_SUCCESS,
    payload: {
        due,
    },
})

export const changeTaskDueDateError = (error) => ({
    type: type.CHANGE_DUE_DATE_ERROR,
    payload: {
        error,
    },
})

export const changeTaskDueDate = (name, due) => (dispatch, getState) => {
    const state = getState()
    const processTaskId = selector.selectTaskId(state)
    if (!processTaskId) {
        return
    }

    dispatch(changeTaskDueDateRequest())

    post('/api/process/task/change-due-date', {
        processTaskId,
        due,
    })
        .then(response => {
            dispatch(changeTaskDueDateSuccess(due))
        })
        .catch(error => {
            dispatch(changeTaskDueDateError())
        })
}

export const changeTaskStatusRequest = () => ({
    type: type.CHANGE_TASK_STATUS_REQUEST,
})

export const changeTaskStatusSuccess = (status) => ({
    type: type.CHANGE_TASK_STATUS_SUCCESS,
    payload: {
        status,
    },
})

export const changeTaskStatusError = (error) => ({
    type: type.CHANGE_TASK_STATUS_ERROR,
    payload: {
        error,
    },
})

export const changeTaskStatus = (name, status) => (dispatch, getState) => {
    const state = getState()
    const processTaskId = selector.selectTaskId(state)
    if (!processTaskId) {
        return
    }

    dispatch(changeTaskStatusRequest())

    post('/api/process/task/change-status', {
        processTaskId,
        status,
    })
        .then(response => {
            dispatch(changeTaskStatusSuccess(status))
        })
        .catch(error => {
            dispatch(changeTaskStatusError())
        })
}


export const triggerEventRequest = () => ({
    type: type.TRIGGER_EVENT_REQUEST,
})

export const triggerEventSuccess = (task) => ({
    type: type.TRIGGER_EVENT_SUCCESS,
    payload: {
        task,
    },
})

export const triggerEventError = (error) => ({
    type: type.TRIGGER_EVENT_ERROR,
    payload: {
        error,
    },
})

export const triggerEventSuccessNoFollowUp = () => ({
    type: type.TRIGGER_EVENT_SUCCESS_NO_FOLLOW_UP_TASK,
})


const validateEvent = (taskName, eventName, state) => {
    const { taskValidatorSelector = [], taskValidator } = getUIDefinitionByTaskName(taskName)

    if (!taskValidator) {
        return null
    }

    const task = selector.selectTask(state)
    const processInstance = selectProcessInstance(state)

    const validatorParameter = []
    for (let index = 0; index < taskValidatorSelector.length; index++) {
        const validatorParameterSelector = taskValidatorSelector[index]
        validatorParameter.push(validatorParameterSelector(state))
    }

    return taskValidator(task, processInstance, taskName, eventName, ...validatorParameter)
}

export const updateValidationMessageList = (validationMessageList) => ({
    type: type.UPDATE_VALIDATION_MESSAGE_LIST,
    payload: {
        validationMessageList,
    },
})

export const validateAndTriggerEvent = (taskName, eventName) => (dispatch, getState) => {
    const state = getState()
    const validationMessageList = validateEvent(taskName, eventName, state)
    if (validationMessageList && validationMessageList.length !== 0) {
        dispatch(updateValidationMessageList(validationMessageList))
        return
    }

    const processTaskId = selector.selectTaskId(state)

    dispatch(triggerEventRequest())

    post('/api/process/task/fire-event', {
        eventName,
        processTaskId,
    })
        .then(task => {
            if (!task.name) {
                dispatch(triggerEventSuccessNoFollowUp())
            } else {
                invokeTaskActionList(task, dispatch)
                enrichTaskDetail(state, task)
                dispatch(triggerEventSuccess(task))
            }
        })
        .catch(error => {
            console.log(error)
            dispatch(triggerEventError(error))
        })
}


export const claimTaskRequest = () => ({
    type: type.CLAIM_TASK_REQUEST,
})

export const claimTaskSuccess = (task) => ({
    type: type.CLAIM_TASK_SUCCESS,
    payload: {
        task,
    },
})

export const claimTaskError = (error) => ({
    type: type.CLAIM_TASK_ERROR,
    payload: {
        error,
    },
})

export const claimTask = () => (dispatch, getState) => {
    const state = getState()
    const processTaskId = selector.selectTaskId(state)

    dispatch(claimTaskRequest())

    get('/api/process/task/claim?processTaskId=' + processTaskId)
        .then(task => {
            dispatch(claimTaskSuccess(task))
        })
        .catch(error => {
            dispatch(claimTaskError(error))
        })
}


export const unClaimTaskRequest = () => ({
    type: type.UN_CLAIM_TASK_REQUEST,
})

export const unClaimTaskSuccess = (task) => ({
    type: type.UN_CLAIM_TASK_SUCCESS,
    payload: {
        task,
    },
})

export const unClaimTaskError = (error) => ({
    type: type.UN_CLAIM_TASK_ERROR,
    payload: {
        error,
    },
})


export const unClaimTask = () => (dispatch, getState) => {
    const state = getState()
    const processTaskId = selector.selectTaskId(state)

    dispatch(unClaimTaskRequest())

    get('/api/process/task/unclaim?processTaskId=' + processTaskId)
        .then(task => {
            dispatch(unClaimTaskSuccess(task))
        })
        .catch(error => {
            dispatch(unClaimTaskError(error))
        })
}

export const changeAssignedTo = (name, value) => ({
    type: type.CHANGE_PROCESS_TASK,
    payload: {
        name: 'assignedToUserId',
        value,
    },
})


export const updateAssignedToUserIdRequest = () => ({
    type: type.UPDATE_ASSIGNED_TO_USER_ID_REQUEST,
})

export const updateAssignedToUserIdSuccess = () => ({
    type: type.UPDATE_ASSIGNED_TO_USER_ID_SUCCESS,
})

export const updateAssignedToUserIdError = (error) => ({
    type: type.UPDATE_ASSIGNED_TO_USER_ID_ERROR,
    payload: {
        error,
    },
})


export const updateAssignedToUserId = () => (dispatch, getState) => {
    const state = getState()
    const { id, assignedToUserId } = selector.selectTask(state)

    dispatch(updateAssignedToUserIdRequest())

    post('/api/process/task/update-assigned-to-user-id', {
        processTaskId: id,
        userId: assignedToUserId,
    })
        .then(task => {
            dispatch(updateAssignedToUserIdSuccess(task))
        })
        .catch(error => {
            dispatch(updateAssignedToUserIdError(error))
        })
}



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/action.js